import React from 'react'
import { observer } from 'mobx-react'
import { restaurantConfig } from 'restaurant'
import { storeMobx } from '@mobxStore'
import { modalLayer } from '@utils'
import { Icon } from '@cps'
import ServiceRingModal from '../ServiceRingModal'
import './index.scss'

interface IProps {
}

const ServiceRing: React.FC<IProps> = () => {
  if (restaurantConfig.codeType !== 'table' || !storeMobx.info.openSendServiceRing || !storeMobx.info.inSale) return null

  const handleSendServiceRing = async () => {
    modalLayer(ServiceRingModal, null, 'ServiceRingModal')
  }

  return (
    <button className='service-ring-button' type='button' onClick={handleSendServiceRing}>
      <Icon name='huaban2' />
    </button>
  )
}

export default observer(ServiceRing)
